import { idbClear, idbDelete, idbGet, idbGetAll, idbPut, STORES } from './database';
import type { LanguageId } from '../pipeline/types';

export interface StoredFileRecord {
  path: string;
  content: string;
  languageId?: LanguageId;
  /** Present only when the file was opened via the File System Access API, so edits can be written back. */
  handle?: FileSystemFileHandle;
  /** Present only for files loaded from a GitHub repo — the blob sha needed to commit an update. */
  githubSha?: string;
  /** contentHash() of `content` as of the last successful fetch/commit — used to detect local edits. */
  githubSyncedHash?: string;
  updatedAt: number;
}

export async function saveFile(record: StoredFileRecord): Promise<void> {
  await idbPut(STORES.files, record);
}

export async function getFile(path: string): Promise<StoredFileRecord | undefined> {
  return idbGet<StoredFileRecord>(STORES.files, path);
}

export async function getAllFiles(): Promise<StoredFileRecord[]> {
  return idbGetAll<StoredFileRecord>(STORES.files);
}

export async function deleteFile(path: string): Promise<void> {
  await idbDelete(STORES.files, path);
}

/** Called when opening a new project, so the file tree doesn't mix files from two different projects. */
export async function clearAllFiles(): Promise<void> {
  await idbClear(STORES.files);
}

const KEY_ROOT_HANDLE = 'projectRootHandle';

export async function saveProjectRootHandle(handle: FileSystemDirectoryHandle): Promise<void> {
  await idbPut(STORES.settings, handle, KEY_ROOT_HANDLE);
}

export async function getProjectRootHandle(): Promise<FileSystemDirectoryHandle | undefined> {
  return idbGet<FileSystemDirectoryHandle>(STORES.settings, KEY_ROOT_HANDLE);
}
